// 企业动态左侧菜单栏假数据
export const newsTypeListData = [
  { id: 2, newType: "论坛中心" },
  { id: 3, newType: "AI新闻" },
  { id: 4, newType: "分享交流" },
  { id: 5, newType: "校园分享" },
  { id: 6, newType: "人才招聘" },
];

// 征稿列表假数据
// level: urgent=急(红色) / normal=征(蓝色) / medium=中(绿色)
// status: open=征稿中（显示"我要投稿"按钮）/ closed=已截止（按钮置灰不可点）
export const contributionListData = [
  {
    id: 1,
    level: "urgent",
    title: "AI大模型在企业中的落地应用实践",
    desc: "面向AI开发者与技术爱好者，征集大模型在企业场景中的实际应用案例与经验总结。稿件需与AI技术相关，字数2000字以上。",
    deadline: "2026-09-30",
    submittedCount: 23,
    status: "open",
  },
  {
    id: 2,
    level: "normal",
    title: "AI赋能教育：从工具到生态",
    desc: "征集AI在教育领域的创新应用文章，包括但不限于智能教学、个性化学习、教育数据分析等方向。",
    deadline: "2026-10-15",
    submittedCount: 8,
    status: "open",
  },
  {
    id: 3,
    level: "medium",
    title: "AIGC内容创作：机遇与挑战",
    desc: "探讨AIGC在内容创作中的变革性影响，征集技术分析、行业观察、实践案例类稿件。",
    deadline: "2026-10-31",
    submittedCount: 15,
    status: "open",
  },
];
// 获取征稿列表（支持分页），返回 Promise，结构与后端接口一致
// params: { pageNumber: 1, pageSize: 10 }
export function getContributionList(params = {}) {
  const { pageNumber = 1, pageSize = 10 } = params;
  const start = (pageNumber - 1) * pageSize;
  const end = start + pageSize;
  const total = contributionListData.length;
  const totalPage = Math.ceil(total / pageSize);
  return Promise.resolve({
    code: 0,
    msg: null,
    data: {
      totalCount: total,
      pageSize,
      totalPage,
      currPage: pageNumber,
      list: contributionListData.slice(start, end),
    },
  });
}
// 获取征稿详情（假数据先用 id 查列表，后续可替换成独立详情接口）
export function getContributionDetail(params = {}) {
  const id = Number(params.id);
  const item = contributionListData.find((row) => row.id === id) || null;
  return Promise.resolve({
    code: item ? 0 : 1,
    msg: item ? null : "征稿不存在",
    data: item,
  });
}
// AI新闻分类标签
// key 用于筛选匹配，label 用于显示
export const aiNewsCategoryTabs = [
  { key: "all", label: "全部" },
  { key: "industry", label: "行业动态" },
  { key: "tech", label: "技术前沿" },
  { key: "policy", label: "政策法规" },
  { key: "company", label: "企业资讯" },
];

// AI新闻列表假数据
// category: 对应 aiNewsCategoryTabs 的 key（all 除外）
// badges: 徽标数组，可同时存在多个；key 在组件内 badgeMap 映射文案和颜色
// imageUrl: 为空时前端渲染渐变占位块
export const aiNewsListData = [
  {
    id: 1,
    category: "industry",
    title: "OpenAI发布GPT-5：多模态能力再升级",
    summary: "OpenAI正式发布GPT-5模型，在文本、图像、音频多模态理解方面实现重大突破，推理能力显著提升，支持更长上下文窗口...",
    imageUrl: "",
    badges: ["hot"],
    createTime: "2026-09-05",
    content: "<p>OpenAI正式发布GPT-5模型，在文本、图像、音频多模态理解方面实现重大突破，推理能力显著提升，支持更长上下文窗口。</p>",
  },
  {
    id: 2,
    category: "industry",
    title: "DeepSeek-V3开源：国产大模型再获突破",
    summary: "DeepSeek发布V3版本模型并完全开源，在多项基准测试中达到GPT-4级别表现，推理成本大幅降低，引发行业广泛关注...",
    imageUrl: "",
    badges: ["new"],
    createTime: "2026-09-03",
    content: "<p>DeepSeek发布V3版本模型并完全开源，在多项基准测试中达到GPT-4级别表现，推理成本大幅降低，引发行业广泛关注。</p>",
  },
  {
    id: 3,
    category: "policy",
    title: "国家出台AI数据合规新规：企业需关注的五大要点",
    summary: "近日国家相关部门发布人工智能数据合规新规，对训练数据来源、用户隐私保护、算法透明度等方面提出明确要求...",
    imageUrl: "",
    badges: [],
    createTime: "2026-08-28",
    content: "<p>近日国家相关部门发布人工智能数据合规新规，对训练数据来源、用户隐私保护、算法透明度等方面提出明确要求。</p>",
  },
  {
    id: 4,
    category: "tech",
    title: "多模态RAG技术实践：让大模型读懂图表",
    summary: "结合视觉编码器与检索增强生成技术，探讨让大模型准确理解表格、图表类文档的主流方案与落地效果...",
    imageUrl: "",
    badges: [],
    createTime: "2026-08-25",
    content: "<p>结合视觉编码器与检索增强生成技术，探讨让大模型准确理解表格、图表类文档的主流方案与落地效果。</p>",
  },
  {
    id: 5,
    category: "company",
    title: "某科技公司宣布全员AI助手计划",
    summary: "该公司将为全体员工配备AI办公助手，覆盖代码编写、文档处理、会议纪要等场景，预计提升30%人均效率...",
    imageUrl: "",
    badges: ["new"],
    createTime: "2026-08-20",
    content: "<p>该公司将为全体员工配备AI办公助手，覆盖代码编写、文档处理、会议纪要等场景，预计提升30%人均效率。</p>",
  },
];
// 获取AI新闻列表（支持分类筛选 + 分页），返回 Promise，结构与后端接口一致
// params: { pageNumber: 1, pageSize: 6, category: "all" }
export function getAiNewsList(params = {}) {
  const { pageNumber = 1, pageSize = 6, category = "all" } = params;
  const filtered =
    category === "all"
      ? aiNewsListData
      : aiNewsListData.filter((item) => item.category === category);
  const start = (pageNumber - 1) * pageSize;
  const end = start + pageSize;
  const total = filtered.length;
  const totalPage = Math.ceil(total / pageSize);
  return Promise.resolve({
    code: 0,
    msg: null,
    data: {
      totalCount: total,
      pageSize,
      totalPage,
      currPage: pageNumber,
      list: filtered.slice(start, end),
    },
  });
}
// 获取AI新闻详情（假数据先用 id 查列表，后续可替换成独立详情接口）
export function getAiNewsInfo(params = {}) {
  const id = Number(params.id);
  const item = aiNewsListData.find((row) => row.id === id) || null;
  return Promise.resolve({
    code: item ? 0 : 1,
    msg: item ? null : "新闻不存在",
    data: item,
  });
}
// 论坛帖子分类标签
export const forumCategoryTabs = [
  { key: "all", label: "全部" },
  { key: "tech", label: "技术干货" },
  { key: "experience", label: "经验分享" },
  { key: "industry", label: "行业观察" },
  { key: "qa", label: "问答求助" },
];

// 论坛帖子列表假数据
// category: 对应 forumCategoryTabs 的 key（all 除外）
// avatar: 头像图片，为空时前端渲染"姓名首字 + 色板取色"占位
// createTime: 假数据直接存相对时间文案；接真实接口后改为时间戳 + 前端格式化
// tags: 自由主题标签数组，值即文案，无需 key 映射
// likes/comments/views: 点赞/评论/浏览数，纯数字，超过 1000 由前端格式化（如 1.2k）
export const forumPostListData = [
  {
    id: 1,
    category: "tech",
    avatar: "",
    username: "李明轩",
    createTime: "2小时前",
    content: "分享一下我们团队在Token聚合平台上的实践经验：通过统一API网关对接多个大模型，企业可以显著降低切换成本。关键技术点在于Token计费对齐和请求路由策略...",
    tags: ["大模型", "API网关", "Token"],
    likes: 42,
    comments: 18,
    views: 568,
  },
  {
    id: 2,
    category: "qa",
    avatar: "",
    username: "王思远",
    createTime: "5小时前",
    content: "求推荐适合中小企业使用的AI客服方案，最好是支持本地部署的，对数据安全要求比较高。有大佬帮忙分析下各家方案的优劣吗？",
    tags: ["AI客服", "本地部署", "问答"],
    likes: 15,
    comments: 7,
    views: 203,
  },
  {
    id: 3,
    category: "experience",
    avatar: "",
    username: "张晓晴",
    createTime: "昨天",
    content: "最近在研究DeepSeek的推理能力，发现它在代码生成场景下表现出非常出色，特别是在复杂逻辑拆解方面。整理了一份对比测试报告，分享给大家参考。",
    tags: ["DeepSeek", "代码生成", "测评"],
    likes: 89,
    comments: 32,
    views: 1200,
  },
  {
    id: 4,
    category: "industry",
    avatar: "",
    username: "陈志强",
    createTime: "2天前",
    content: "观察了近半年大模型行业的招标数据，企业采购重心已经从「训练自有模型」转向「采购推理服务」，应用层厂商的机会窗口正在打开...",
    tags: ["行业趋势", "大模型"],
    likes: 36,
    comments: 11,
    views: 465,
  },
];

// 获取论坛帖子列表（支持分类筛选 + 分页），返回 Promise，结构与后端接口一致
// params: { pageNumber: 1, pageSize: 6, category: "all" }
export function getForumPostList(params = {}) {
  const { pageNumber = 1, pageSize = 6, category = "all" } = params;
  const filtered =
    category === "all"
      ? forumPostListData
      : forumPostListData.filter((item) => item.category === category);
  const start = (pageNumber - 1) * pageSize;
  const end = start + pageSize;
  const total = filtered.length;
  const totalPage = Math.ceil(total / pageSize);
  return Promise.resolve({
    code: 0,
    msg: null,
    data: {
      totalCount: total,
      pageSize,
      totalPage,
      currPage: pageNumber,
      list: filtered.slice(start, end),
    },
  });
}
// 校园分享-已提交方案列表假数据
// status: adopted=已采纳(绿) / reviewing=审核中(橙) / pending=未采纳(灰)
// 卡片顶部色条和状态徽标都由组件内 statusMap 按 status 统一映射，数据里不存颜色
export const campusProposalListData = [
  {
    id: 1,
    school: "厦门大学",
    title: "AI+校园Hackathon创意马拉松",
    desc: "围绕AI主题，组织48小时创意开发马拉松，学生组队参与，优秀项目可获得青叶智能技术支持与孵化机会。",
    status: "adopted",
    createTime: "2026-08-15",
  },
  {
    id: 2,
    school: "福州大学",
    title: "AI科普进校园系列讲座",
    desc: "邀请青叶智能技术专家走进校园，开展系列AI科普讲座，覆盖大模型基础、AIGC应用、职业发展等主题。",
    status: "reviewing",
    createTime: "2026-09-01",
  },
  {
    id: 3,
    school: "华侨大学",
    title: "AI+文创设计大赛",
    desc: "结合AIGC技术与校园文创，举办设计大赛，学生使用AI工具创作校园主题文创作品，优秀作品量产化。",
    status: "reviewing",
    createTime: "2026-09-05",
  },
  {
    id: 4,
    school: "集美大学",
    title: "校园AI辩论赛",
    desc: "以「AI是否会取代人类」为辩题，组织校际辩论赛，搭配AI辅助分析辩手表现的创新环节。",
    status: "pending",
    createTime: "2026-08-20",
  },
];

// 获取校园方案列表（支持分页），返回 Promise，结构与后端接口一致
// params: { pageNumber: 1, pageSize: 6 }
export function getCampusProposalList(params = {}) {
  const { pageNumber = 1, pageSize = 6 } = params;
  const start = (pageNumber - 1) * pageSize;
  const end = start + pageSize;
  const total = campusProposalListData.length;
  const totalPage = Math.ceil(total / pageSize);
  return Promise.resolve({
    code: 0,
    msg: null,
    data: {
      totalCount: total,
      pageSize,
      totalPage,
      currPage: pageNumber,
      list: campusProposalListData.slice(start, end),
    },
  });
}
export function getCampusProposalInfo(params = {}) {
  const id = Number(params.id);
  const item = campusProposalListData.find((row) => row.id === id) || null;
  return Promise.resolve({
    code: item ? 0 : 1,
    msg: item ? null : "方案不存在",
    data: item,
  });
}
// 人才招聘-在招岗位列表假数据
// salary: 薪资范围文案（含单位，如 200-300/天），前端红色强调显示
// tags: 岗位要求标签数组（技术栈/经验/学历），值即文案，无需映射
// city/jobType/createTime: 底部一行展示的城市/职位性质/发布时间
export const jobPositionListData = [
  {
    id: 1,
    title: "AI算法工程师",
    salary: "15K-30K",
    tags: ["大模型", "NLP", "3-5年经验", "本科及以上"],
    city: "厦门",
    jobType: "全职",
    createTime: "2026-09-01",
  },
  {
    id: 2,
    title: "前端开发工程师",
    salary: "12K-22K",
    tags: ["Vue/React", "TypeScript", "1-3年经验", "本科及以上"],
    city: "厦门",
    jobType: "全职",
    createTime: "2026-08-28",
  },
  {
    id: 3,
    title: "产品经理（AI方向）",
    salary: "15K-25K",
    tags: ["AI产品", "B端", "3-5年经验", "本科及以上"],
    city: "厦门",
    jobType: "全职",
    createTime: "2026-08-25",
  },
  {
    id: 4,
    title: "校园招聘-实习生",
    salary: "200-300/天",
    tags: ["应届生", "AI/开发", "实习", "在校生"],
    city: "厦门",
    jobType: "实习",
    createTime: "2026-09-05",
  },
];

// 获取在招岗位列表（支持分页），返回 Promise，结构与后端接口一致
// params: { pageNumber: 1, pageSize: 6 }
export function getJobPositionList(params = {}) {
  const { pageNumber = 1, pageSize = 6 } = params;
  const start = (pageNumber - 1) * pageSize;
  const end = start + pageSize;
  const total = jobPositionListData.length;
  const totalPage = Math.ceil(total / pageSize);
  return Promise.resolve({
    code: 0,
    msg: null,
    data: {
      totalCount: total,
      pageSize,
      totalPage,
      currPage: pageNumber,
      list: jobPositionListData.slice(start, end),
    },
  });
}



// WEBPACK FOOTER //
// ./src/data/newsData.js